import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';
import { environment } from '../../shared/config/app-config';
import { UserService, PatientService, User } from '../../shared';
@Pipe({
  name: 'dischargedateFormat'
})
export class DischargedateFormatPipe implements PipeTransform {
  dateform: string;
  currentUser: User;
  constructor(private userService: UserService,private Datepipe:DatePipe)
  {}
  transform(value: any): any {
    var changedFormat
    try{
      this.userService.currentUser.subscribe(
        (userData) => {
          this.currentUser = userData;
          if(this.currentUser.item){
            if(this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy'){
              this.dateform = environment.dateForm;
            }else if(this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy'){
              this.dateform = 'dd/MM/yyyy'
            }
            changedFormat = this.Datepipe.transform(value, this.dateform);
          }
        }
      );
      
      }
      catch (Exception){
        changedFormat = '';
      }
  
    return changedFormat;

  }

}
